/** Türkçe sözlük · iceAktar. Şekli bu dosya tanımlar; öteki diller ona bağlıdır. */
export const iceAktar = {
  /** `screens/IceAktarScreen.tsx` */
  ekran: {
    baslik: "İçe aktar",
    aciklama: "Başka bir uygulamadan hesap ve hareketleri CSV dosyasıyla getirin.",
    hesapTuru: {
      araci_kurum: "Aracı kurum",
      banka: "Banka",
      cuzdan: "Cüzdan",
      borsa: "Kripto borsası",
      fiziki: "Fiziki",
    },
    durum: {
      yeni: "eklenecek",
      guncellenecek: "güncellenecek",
      ayni: "zaten aynı",
      silinmis: "Parafon'da silinmiş — diriltilmez",
    },
    merkezYokKatalog: "Merkez bağlı değil — katalogda aranamadı.",
    katalogdaYokDisArama:
      "Katalogda yok ve dış arama şu an yapılamadı (bulunamadı demek değil); sonra yeniden deneyin ya da elle değerleyin.",
    katalogdaBulunamadi: "Katalogda bulunamadı.",
    aramaYapilamadi: (hata: string) => `Arama yapılamadı: ${hata}`,
    merkezYokTefas: "Merkez bağlı değil — TEFAS fiyatı alınamadı.",
    tefasSorulamadiHata: (hata: string) => `TEFAS fiyatı sorulamadı: ${hata} — sonra yeniden deneyin.`,
    varlikEslestirilmedi: "Varlık eşleştirilmedi",
    elleTefasYok: "Elle değerlenen varlıkta TEFAS arşivi yok; fiyatı dosyaya yazın.",
    tefasSorulamadi: "TEFAS fiyatı sorulamadı.",
    kilitKurumEkstresi: "Kurum ekstresinden içe aktarmak",
    kilitDosya: "Dosyadan içe aktarmak",
    pdfMetinYok: (ad: string) =>
      `${ad}: sayfalarda okunabilir yazı yok (taranmış görüntü olabilir); böyle ekstreler okunamaz.`,
    ekstreTaninmadi: (sebep: string) =>
      `${sebep} Kurumunuzun ekstresi henüz okunmuyorsa biçimini aşağıdaki karttan paylaşabilirsiniz.`,
    karisikDosya: "Ya bir CSV dosyası ya da bir ya da birkaç PDF ekstresi seçin (TL ve döviz ekstresi birlikte).",
    sorunSutunu: "Sorun",

    dosya: {
      baslik: "1 · Dosya",
      aciklama:
        "Bir satır bir hareket. Sütunlar ve örnek için şablonu indirin. Excel'den \"CSV olarak kaydet\" yeterli. Aynı dosyayı ikinci kez yüklemek hiçbir şeyi çiftlemez.",
      sec: "Dosya seç",
      secEtiket: "İçe aktarılacak dosya",
      sablonIndir: "Şablonu indir",
      ekstreOkunamadi: "Ekstre okunamadı",
      parola: "Ekstre parolası",
      parolaIpucu: "Yalnızca dosyayı açmak için; saklanmaz.",
      parolaTutmadi: "Parola tutmadı.",
      ac: "Aç",
      tanindi: (ad: string) => `${ad} tanındı`,
      midasAciklama: (belgeler: string, atlanan: number) =>
        `${belgeler}. Hepsi tek hesaba yazılır; döviz alış/satışın TL ve döviz yarıları saatlerinden eşleştirilir.` +
        (atlanan > 0 ? ` Gerçekleşmeyen ${atlanan} emir ya da işlem atlandı.` : ""),
      sayiBicimi: "Sayı biçimi",
      bicimAnlasilamadi: "Dosyadan anlaşılamadı; seçin.",
      bicimOnerildi: "Dosyaya göre önerildi; yanlışsa değiştirin.",
      bicimTr: "Türkçe — 1.234,56",
      bicimEn: "İngilizce — 1,234.56",
      sutunEksik: "Zorunlu sütun eksik",
      sutunEksikAciklama: (eksik: string, baslik: string) =>
        `Bulunamayan: ${eksik}. Başlık satırındaki adlar: ${baslik}.`,
      oncesiTur: (paraBirimi: string) =>
        `Tür, miktarın işaretinden okunur (+ alış, − satış). Para birimi başlıktan: ${paraBirimi}.`,
      oncesiTefas: " Öneksiz fon kodları TEFAS fonu olarak aranır.",
      oncesiDengeleme: " \"Evet\" işaretli portföy değiştirme / dengeleme satırları nota yazılır.",
      oncesiYokSayilan: (liste: string) => ` Yok sayılan: ${liste} — kur merkezin TCMB arşivinden alınır.`,
      windows1254: " Dosya Türkçe Windows kodlamasıyla okundu.",
      pdfTablo: " Tablo PDF'ten okundu; alt satıra taşan hücreler birleştirildi.",
      bilinmeyenSutunlar: (liste: string) => `Tanınmayan sütunlar yok sayıldı: ${liste}.`,
    },

    hesaplar: {
      baslik: "2 · Hesaplar",
      satirYok: "Okunan satır yok.",
      grup: (ad: string) => `Hesap: ${ad}`,
      kimlik: (k: string) => `kimlik ${k}`,
      buHesap: "Bu hesap",
      secin: "Seçin",
      yeniEkle: "Yeni hesap olarak ekle",
      varOlan: (ad: string, devreDisi: boolean) => `Var olan: ${ad}${devreDisi ? " (devre dışı)" : ""}`,
      devreDisiBaslik: "Bu hesap devre dışı",
      devreDisiAciklama:
        "Yüklenebilir: hareketler kasaya yazılır ama hesap tekrar açılana kadar Hesaplar sayfası dışında görünmez ve toplamlara girmez. Hesaplar sayfasından \"Tekrar aç\" ile açabilirsiniz.",
      birdenCok: "Bu kurumdan birden çok hesap var; hangisine yükleneceğini seçin.",
      hesapAdi: "Hesap adı",
      araciKurum: (ad: string) => `Aracı kurum: ${ad}`,
      adBos: "Ad boş olamaz.",
      tur: "Tür",
      anaParaBirimi: "Ana para birimi",
    },

    varliklar: {
      baslik: "3 · Varlıklar",
      grup: (ad: string) => `Varlık: ${ad}`,
      araniyor: "Katalogda aranıyor…",
      birdenCok: "Birden çok eşleşme var; birini seçin.",
      elleEkle: "Elle değerlenen varlık olarak ekle",
      secmezseniz: "Seçmezseniz bu varlığın satırları eklenmez, sorunlu satırlara düşer.",
      elle: "Elle değerlenen varlık — fiyatı Elle fiyat ekranından girilir.",
      yok: "Varlık yok.",
    },

    onizleme: {
      baslik: "4 · Önizleme",
      okundu: (n: number, sorunlu: number) =>
        `${n} satır okundu${sorunlu > 0 ? `, ${sorunlu} satır sorunlu (eklenmez)` : ""}.`,
      geriYatirim: (n: number, desenden: number) =>
        `${n} satır geri yatırılan temettü olarak okundu` +
        (desenden > 0 ? ` (${desenden} tanesi "alış + eksi masraf + temettü" deseninden)` : "") +
        ": her biri bir temettü geliri ve aynı tutarda bir alış olarak eklenir.",
      arsivden: (n: number) => `${n} satırın birim fiyatı o günün TEFAS fiyatından alındı (hareketin notunda yazar).`,
      bekleniyor: (n: number) =>
        `${n} satırın TEFAS fiyatı henüz alınamadı (fon geçmişi merkezde indiriliyor olabilir).`,
      yenidenSor: "TEFAS fiyatlarını yeniden sor",
      hazirDegil: "Hesap ve varlık seçimleri tamamlanınca önizleme hazırlanır.",
      ozetEtiket: "Portföy özetiyle karşılaştırma",
      ozetBaslik: (tarih: string) => `Ekstrenin portföy özeti (${tarih}) ile kasa, içe aktarılacaklar dahil:`,
      ozetTutuyor: (n: number) => `${n} varlığın adedi tutuyor.`,
      ozetTutmuyor: (n: number) => `${n} varlıkta adet tutmuyor.`,
      uyari: "Uyarı",
      ekstrede: "ekstrede",
      kasada: "kasada",
      eslesmedi: "varlık eşleşmedi",
      oncekiDonemler: "Ekstre hesabın açılışından başlamıyorsa önceki dönemlerin ekstrelerini de içe aktarın.",
      sayilarEtiket: "Önizleme sayıları",
      hesapSayisi: (n: number) => `${n} hesap`,
      ve: " ve ",
      hareketSayisi: (n: number) => `${n} hareket`,
      sorunlu: "Sorunlu satırlar",
      satir: (n: number) => `Satır ${n}:`,
      sorunluIndir: "Sorunlu satırları indir",
      csvDosyasi: "CSV dosyası",
      kilitAciklama: "Dosya okundu ve önizlendi; kayıtlar yazılmadı.",
      kilitYeniHesap: "Bu dosyadaki yeni hesapları eklemek",
      kilitHesapAciklama: (etkin: number, yeni: number, sinir: number) =>
        `Kasada ${etkin} etkin hesap var, dosya ${yeni} yeni hesap ekliyor; sınır ${sinir}.`,
      yaziliyor: "Yazılıyor…",
      yazilacakYok: "Yazılacak bir şey yok",
      iceAktar: (n: number) => `İçe aktar (${n} kayıt)`,
      tamamBaslik: "İçe aktarma tamamlandı",
      tamam: (hesap: number, hareket: number, guncel: number) =>
        `${hesap} hesap eklendi, ${hareket} hareket eklendi, ${guncel} kayıt güncellendi.`,
      izlenemeyen: (liste: string) => `Fiyat izlemesine alınamayanlar (sonra İzleme ekranından): ${liste}.`,
    },
  },

  /** `components/ImportReport.tsx` */
  rapor: {
    tur: {
      accounts: "Hesap",
      transactions: "Hareket",
      manualValuations: "Elle değerleme",
      manualPrices: "Elle fiyat",
      settings: "Ayar",
    },
    bos: "Bu dosyada hiç kayıt yok — boş bir yedek. Kasanızdaki kayıtlara dokunulmadı.",
    hepsiAyni: "Dosyadaki kayıtların tamamı kasanızda aynen mevcuttu; değişen bir şey yok.",
    hicYazilmadi: "Hiçbir kayıt yazılmadı — ayrıntılar aşağıda.",
    dosyada: "dosyada",
    yazildi: "yazıldı",
    zatenAyni: "zaten aynı",
    atlandi: "atlandı",
    atlananlar: (n: string) => `${n} kayıt atlandı — nedenleri`,
    hicAtlanmadi: "Hiçbir kayıt atlanmadı.",
  },

  /** `components/EkstreMaskeKarti.tsx` */
  maske: {
    yok: "Yok.",
    kapat: "Kapat",
    ac: "Aç",
    tumunuGoster: "Tümünü göster",
    ozet: (sayfa: number, parca: number) =>
      `${sayfa} sayfa, ${parca} metin parçası. Aşağıdaki önizleme, inecek dosyanın aynısıdır.`,
    sayfa: "Sayfa",
    onizleme: "Maskeli önizleme",
    kelimeIpucu:
      "Görünmesini istemediğiniz bir kelime açıksa üstüne dokunup kapatın. Kapalı kalan bir sütun adını açabilirsiniz.",
    acikKelimeler: "Açık kalan kelimeler",
    kapaliKelimeler: "Kapalı kelimeler",
    indir: "Maskeli dosyayı indir",
    baslik: "Kurum ekstresi · biçimini paylaşın",
    aciklama:
      "Kurum ekstreleri (PDF) henüz doğrudan okunmuyor; ilk kurum Midas. Okuyucu için ekstrenin düzeni yeter, içindekiler gerekmez. Rakamlar 9, adlar ve kodlar X olur; yalnızca \"Tarih\", \"Adet\" gibi başlık kelimeleri açık kalır. PDF bu cihazda işlenir ve saklanmaz; maskeli dosyayı siz indirip paylaşırsınız ya da gördüğünüz metni onaylayıp geliştirmeye gönderirsiniz.",
    pdfSec: "PDF seç",
    pdfEtiket: "Maskelenecek ekstre (PDF)",
    temizle: "Temizle",
    okunuyor: "PDF okunuyor",
    parola: "PDF parolası",
    parolaIpucu: "Yalnızca bu dosyayı açmak için; saklanmaz.",
    parolaTutmadi: "Parola tutmadı.",
    metinYokBaslik: "Bu PDF'te metin yok",
    metinYok: (n: number) =>
      `${n} sayfanın hiçbirinde okunabilir yazı bulunamadı; sayfalar görüntü olarak taranmış olabilir. Böyle ekstreler okunamaz. Kurumun sitesinden indirilen PDF ya da Excel'i deneyin.`,
    okunamadi: "PDF okunamadı",
  },

  /** `components/GeriBildirimKarti.tsx`, `components/SatirGeriBildirimi.tsx`, `lib/geriBildirim.ts` */
  geriBildirim: {
    merkezYok: "Merkez bu oturumda bağlı değil; gönderilemez.",
    ac: "Geliştirmeye gönder…",
    grup: "Geliştirmeye gönder",
    aciklama: (gun: number) =>
      `Aşağıdaki metin yalnızca "Gönder"e basarsanız Parafon sunucusuna gider ve bir sonraki geliştirmede incelenir. Kimin gönderdiği, cihaz, kasa ya da hesap bilgisi gitmez; rakamlar 9, tanınmayan adlar X olur. İşlenen kayıt silinir; işlenmezse ${gun} gün sonra kendiliğinden silinir.`,
    metin: "Gönderilecek metin",
    gonderilemezBaslik: "Bu metin gönderilemez",
    sinirAsiyor: "Metin sunucunun sınırını aşıyor; dosyayı indirip paylaşın.",
    sebep: (sebep: string) => `Sebep: ${sebep}.`,
    gonderildi: "Gönderildi",
    basvuruKodu: "Başvuru kodu:",
    buKodla: ". Bu kodla sorabilirsiniz.",
    gonderiliyor: "Gönderiliyor…",
    gonder: "Gönder",
    vazgec: "Vazgeç",
    gonderilemedi: "Gönderilemedi",
    // Sunucuya gönderimin hataları (`lib/geriBildirim.ts`).
    gonderilemez: (sebep: string) => `Gönderilemez: ${sebep}.`,
    cokGonderim: "Sunucu bu bağlantıdan kısa sürede çok gönderim aldı; bir saat sonra yeniden deneyin.",
    dolu: "Sunucuda inceleme bekleyen kayıt sınırı dolu; daha sonra yeniden deneyin.",
    yanitAnlasilamadi: "Sunucunun yanıtı anlaşılamadı.",
    // Gönderilecek metnin iskeleti (ekranda birebir görünür).
    metinBaslik: "Parafon · içe aktarılamayan satırlar",
    metinBicim: (ad: string) => `Biçim: ${ad}`,
    metinKural: "Kural: rakam → 9; sözlükte olmayan harf → X/x",
    metinSorun: "Sorun:",
    // Satır geri bildirimi.
    satirSiniri: (n: number) => `Yalnızca ilk ${n} satır gönderilir.`,
    kelimeIpucu:
      "Görünmesini istemediğiniz bir kelime açıksa üstüne dokunup kapatın; tanınması için gereken bir kelime (ör. işlem türü) kapalıysa açabilirsiniz.",
  },

  /** `lib/iceAktarma.ts`: satır sorunları. */
  okuma: {
    alan: {
      miktar: "Miktar",
      fiyat: "Fiyat",
      tutar: "Tutar",
      masraf: "Masraf",
      vergi: "Vergi",
      alinanTutar: "Alınan tutar",
    },
    sayiOkunamadi: (alan: string, ham: string, ornek: string) => `${alan} okunamadı: "${ham}" (sayı biçimi ${ornek})`,
    haneTasiyor: (alan: string, hane: number, deger: string, sinir: number) =>
      `${alan} ${hane} ondalık hane taşıyor (${deger}); Parafon en fazla ${sinir} hane saklar, yuvarlanmaz`,
    tarihOkunamadi: (ham: string) => `Tarih okunamadı: "${ham}" (GG.AA.YYYY ya da YYYY-AA-GG)`,
    valorOkunamadi: (ham: string) => `Valör okunamadı: "${ham}"`,
    valorOnce: "Valör, işlem tarihinden önce olamaz",
    hesapBos: "Hesap boş",
    turAnlasilmadi: (ham: string) => `Tür anlaşılmadı: "${ham}"`,
    paraBirimiYok: (ham: string, liste: string) => `Para birimi listede yok: "${ham}" (${liste})`,
    masrafEksiTemettusuz: "Masraf eksi olamaz (açıklamada \"temettü\" yoksa geri yatırım sayılmaz)",
    eksiMasrafTutmuyor: (masraf: string, alis: string) =>
      `Eksi masraf (${masraf}) alış tutarına (miktar × fiyat = ${alis}) eşit değil — geri yatırılan temettü olarak okunamadı`,
    masrafEksi: "Masraf eksi olamaz",
    temettuBelirsiz:
      "Açıklamada \"temettü\" var ama eksi masraf (temettü tutarı) yok — geri yatırılan temettü mü, alış mı anlaşılamadı. " +
      "Düzeltme: temettüyse masrafa eksi temettü tutarını yazın; alışsa açıklamadan \"temettü\"yü kaldırın",
    vergiEksi: "Vergi eksi olamaz",
    alinanTutarGerekli: "Alınan tutar gerekli (döviz alış/satış)",
    alinanTutarSifir: "Alınan tutar sıfırdan büyük olmalı",
    alinanParaBirimiYok: (ham: string, liste: string) => `Alınan para birimi listede yok: "${ham}" (${liste})`,
    alinanParaBirimiAyni: "Alınan para birimi verilenden farklı olmalı",
    alinanYalnizDoviz: "Alınan tutar ve para birimi yalnızca döviz alış/satışta olabilir",
    tutarGerekli: "Tutar gerekli (nakit hareketi)",
    tutarSifir: "Tutar sıfırdan büyük olmalı",
    temettudeVarlik: "Temettüde varlık gerekli",
    varlikGerekli: "Varlık gerekli",
    miktarGerekli: "Miktar gerekli",
    miktarSifir: "Miktar sıfırdan büyük olmalı",
    fiyatGerekli: "Fiyat gerekli",
    fiyatEksi: "Fiyat eksi olamaz",
    carpimSigmiyor: "Miktar × fiyat 12 ondalık haneye sığmıyor",
    kimlikTekrar: (kimlik: string) => `Kaynak kimliği dosyada birden çok kez geçiyor: ${kimlik}`,
  },

  /** `lib/midasEkstre.ts`: kurum ekstresinin okunamayan satırları. */
  midas: {
    ad: "Midas hesap ekstresi",
    sutunSayisi: (bulunan: number, beklenen: number, metin: string) =>
      `${bulunan} sütun var, ${beklenen} bekleniyordu (${metin})`,
    sutunBeklenmedik: (no: number, metin: string) => `${no}. sütun beklenmedik: "${metin}"`,
    transferVar: "Hisse transferi bölümünde satır var; bu bölüm henüz okunmuyor.",
    baslikTaninmadi: (belge: string, bolum: string, sebep: string) => `${belge}: ${bolum} başlığı tanınmadı — ${sebep}`,
    emirDurumu: (durum: string) => `Emir durumu tanınmadı: "${durum}" (gerçekleşen fiyat var)`,
    satirOkunamadi: "Satır okunamadı (tarih, yön, adet, fiyat ya da tutar)",
    adetFiyatTutar: "Adet, fiyat ya da tutar okunamadı",
    tutarTutmuyor: (carpim: string, tutar: string) =>
      `Adet × ortalama fiyat (${carpim}) işlem tutarını (${tutar}) tutmuyor`,
    birimFiyat: "Birim fiyat hesaplanamadı",
    hesapIslemiOkunamadi: "Hesap işlemi okunamadı (tarih ya da tutar)",
    hesapIslemiTaninmadi: (tip: string, aciklama: string | null) =>
      `Hesap işlemi tanınmadı: "${tip}"${aciklama === null ? "" : ` (${aciklama})`}`,
    temettuOkunamadi: "Temettü satırı okunamadı",
    temettuTutmuyor: (brut: string, stopaj: string, net: string) =>
      `Brüt − stopaj (${brut} − ${stopaj}) net temettüyü (${net}) tutmuyor`,
    dosyaYok: "Dosya yok.",
    taninmayan: (adlar: string) => `${adlar}: tanınan bir kurum ekstresi değil.`,
    dovizYarisiYok: (alis: boolean, belge: string) =>
      `Döviz ${alis ? "alışının" : "satışının"} öbür yarısı yok (${belge}): TL ve döviz ekstrelerini birlikte seçin`,
    dovizCoklu: "Aynı anda birden çok döviz işlemi: eşleştirilemedi",
    kurFarkli: (a: string, b: string) => `İki ekstredeki kur farklı (${a} / ${b})`,
  },

  /** `lib/parafonOncesi.ts` */
  oncesi: {
    ad: "Parafon öncesi kayıt dosyası",
    dengelemeAnlasilmadi: (ham: string) =>
      `Portföy değiştirme / dengeleme anlaşılmadı: "${ham}" (Evet / Hayır)`,
    arsivYok: "Fonun fiyat geçmişi merkezde henüz yok; indiriliyor olabilir — sonra yeniden deneyin.",
    ufukOncesi: (gun: string, baslangic: string) =>
      `${gun}: merkezin fiyat geçmişi ${baslangic} tarihinden başlıyor; bu gün için fiyat alınamaz.`,
    indirilmedi: (gun: string, from: string, to: string) =>
      `${gun}: merkez bu günü henüz indirmedi (elde ${from} – ${to}); sonra yeniden deneyin.`,
    bosluk: (gun: string) => `${gun}: kaynakta bu gün eksik (bilinen boşluk); fiyatı dosyaya yazın.`,
    yayimlanmamis: (gun: string) =>
      `${gun}: TEFAS bu gün fiyat yayımlamamış (hafta sonu ya da tatil olabilir); tarihi ya da fiyatı kontrol edin.`,
  },

  /**
   * Uygulamanın içe aktarmada hareket notuna yazdığı metinler (kullanıcı
   * kararı 01.11.2026): içe aktarma anındaki dilde yazılır, sonra kasada
   * olduğu gibi kalır (dil değişince değişmez).
   */
  not: {
    nemaGeliri: "nema geliri",
    stopaj: "stopaj",
    odemeTarihi: "ödeme tarihi",
    kismenAdet: (adet: string, gerceklesen: string) => `kısmen gerçekleşti (emir adedi ${adet}, gerçekleşen ${gerceklesen}; kalanı iptal)`,
    kismenTutar: (tutar: string, gerceklesen: string) => `kısmen gerçekleşti (emir tutarı ${tutar}, gerçekleşen ${gerceklesen}; kalanı iptal)`,
    birimFiyat: (ortalama: string) => `birim fiyat = işlem tutarı ÷ adet (ekstrede ortalama ${ortalama})`,
    kur: (kur: string) => `kur ${kur}`,
    dengeleme: "Portföy değiştirme / dengeleme",
    arsivFiyati: (gun: string) => `Birim fiyat TEFAS arşivinden (${gun})`,
  },

  /** `lib/pdfMetin.ts`, `lib/files.ts` */
  pdfGecersiz: "Dosya geçerli bir PDF değil.",
  dosyaOkunamadi: "Dosya okunamadı.",
};
